// removed by extract-text-webpack-plugin
module.exports = {"layoutSidebar":"SideDrawer__layoutSidebar__2VPv0","Open":"SideDrawer__Open__1jKBI","Close":"SideDrawer__Close__3W4O9","sidebarLogo":"SideDrawer__sidebarLogo__2bmsR","sidebarContent":"SideDrawer__sidebarContent__3IOiW","sidebarLogoImg":"SideDrawer__sidebarLogoImg__1ufwY","sidebarLink":"SideDrawer__sidebarLink__2vaJ6","sidebarLinkActive":"SideDrawer__sidebarLinkActive__3VycZ","Icon":"SideDrawer__Icon__1rbZh","footer":"SideDrawer__footer__3XeDH","footerImage":"SideDrawer__footerImage__3ojSi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CommonComponents/SideDrawer/SideDrawer.css
// module id = 118
// module chunks = 0